module.exports = __webpack_public_path__ + "media/images/icons/linkedin-cadd4c698e39bc647ea243b693c1e94b.svg";